import { Button, Form } from 'antd';
import { useContext } from 'react';
import { ContextApp } from '../../../contexts/ContextApp';
import '../ViewWorkflowModal.less';

interface OnlySaveBtnGroupProps {
  onCancel?: () => void;
  handleStepZeroSubmit: (
    isRejectedValue: boolean,
    nextTask: string,
    finalize?: boolean,
  ) => Promise<void>;
  nextActivityData: {
    approval: string;
    decline: string;
  };
}
const OnlySaveBtnGroup = (props: OnlySaveBtnGroupProps) => {
  const { onCancel, handleStepZeroSubmit, nextActivityData } = props;
  const { t } = useContext(ContextApp);

  return (
    <Form.Item id="button">
      <div className="button-container">
        <Button onClick={onCancel}>{t('action.cancel')}</Button>

        <Button
          type="primary"
          htmlType="button"
          onClick={async () => {
            try {
              handleStepZeroSubmit(false, nextActivityData.approval, false);
            } catch (err) {}
          }}
        >
          {t('action.saveAndContinue')}
        </Button>
      </div>
    </Form.Item>
  );
};
export default OnlySaveBtnGroup;
